export namespace ArrayHelper {
    /**
     * Shallow array value comparison. Returns TRUE if the array values are identical, FALSE if array values are different.
     * @param array1
     * @param array2
     */
    export function compare<T>(array1: T[], array2: T[]): boolean {
        if (array1 === array2) return true;
        if (array1 == null || array2 == null) return false;
        if (array1.length !== array2.length) return false;
        for (let i = 0; i < array2.length; ++i) {
            if (array1[i] !== array2[i]) return false;
        }
        return true;
    }

    export function includes<T>(array: T[], valueToFind: T): boolean {
        return array.indexOf(valueToFind) !== -1;
    }

    export function excludes<T>(array: T[], valueToFind: T): boolean {
        return !includes(array, valueToFind);
    }

    export function intersection<T>(array1: T[], array2: T[]): T[] {
        return array1.filter(x => includes(array2, x));
    }

    export function difference<T>(array1: T[], array2: T[]): T[] {
        return array1.filter(x => excludes(array2, x));
    }

    export function symmetricDifference<T>(array1: T[], array2: T[]): T[] {
        return difference(array1, array2).concat(difference(array2, array1));
    }

    export function range(
        start: number,
        end: number,
        step: number = 1
    ): number[] {
        if (start > end) step *= -1;
        const length = Math.floor(Math.abs((end - start) / step)) + 1;
        return Array.from(Array(length), (x, index) => start + index * step);
    }
}
